import {ValueObject} from '@s-ui/domain'

export class BuyerIntentionsSellerValueObject extends ValueObject {
  #buyerIntentions

  constructor({buyerIntentions}) {
    super()
    this.#buyerIntentions = buyerIntentions
  }

  static create({buyerIntentions} = {}) {
    return new BuyerIntentionsSellerValueObject({buyerIntentions: buyerIntentions || []})
  }

  get value() {
    return this.#buyerIntentions
  }
}
